import VerticalLinearStepper, {
	IVerticalLinearStepper,
	IStep
} from './VerticalLinearStepper';

export type { IVerticalLinearStepper, IStep };
export default VerticalLinearStepper;
